import { useEffect, useState, useRef } from "react";
import { Button, Modal, Card, Form, Tab, Nav, Dropdown } from "react-bootstrap";
import styles from "./ClaimChoicePop.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  claimExternalApi,
  getConversionPrice,
  claimBitanicaApi,
  getPaymentStatus
} from "../../../lib/store/actions";
import { showToast } from "../../../helper/common";
import styled from "styled-components";
import { createPortal } from "react-dom";
import LoaderCstm from "../../Loader";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";

const ClaimChoicePop = ({
  showChoicePop,
  setShowChoicePop,
  item,
  isBitanicaLinked,
  isWalletConnected,
}) => {
  // const { t } = useTranslation();
  const t = useLanguage();

  // console.info("isBitanicaLinked", isBitanicaLinked);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { settings, paymentStatus, paymentStatusLoading } = useSelector(({ Settings }) => Settings);
  const isTGWithdrawalLoading = !paymentStatus || paymentStatusLoading;
  const isTGWithdrawalDisabled = isTGWithdrawalLoading || paymentStatus?.telegramWithDrawStatus === "disabled";

  const defaultPlatform = isBitanicaLinked
    ? "Bitanica"
    : isWalletConnected && !isTGWithdrawalDisabled
      ? "External"
      : "Bitanica";
  const [selectedPlatform, setSelectedPlatform] = useState(defaultPlatform);
  const switchTimeoutRef = useRef(null);
  const [activeTab, setActiveTab] = useState(
    defaultPlatform === "Bitanica" ? "first" : "second"
  );

  useEffect(() => {
    return () => {
      if (switchTimeoutRef.current) {
        clearTimeout(switchTimeoutRef.current);
      }
    };
  }, []);
  const defaultCurrency =
    item?.coinSymbol?.toLowerCase() === "usdt"
      ? "USDT"
      : item?.coinSymbol?.toLowerCase() === "ton"
        ? "TON"
        : "";
  const [selectedCurrency, setSelectedCurrency] = useState(defaultCurrency);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [amountPercentage, setAmountPercentage] = useState(100);
  const [selectedItem, setSelectedItem] = useState(null);
  const [amountValue, setAmountValue] = useState(0);
  const [convertedAmount, setConvertedAmount] = useState(0);
  const [commissionAmount, setCommissionAmount] = useState(0);
  const { conversionPrice } = useSelector(({ Game }) => Game);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (selectedPlatform === "Bitanica" && isBitanicaLinked) {
        // console.info("amountValue", amountValue)
        if (item.type !== "expiry" && amountValue === 0) {
          showToast(`Please select amount to claim!`, "error");
          return;
        }
        setLoading(true);
        dispatch(
          claimBitanicaApi({
            data: {
              _id: item?._id,
              amount: item?.type === "expiry" ? item?.leftAmount : amountValue,
            },
            callBack: (err, res) => {
              if (err) {
                console.error("error claim external", err);
              }
              setLoading(false);
              setSelectedPlatform("Bitanica");
              setSelectedCurrency("");
              setAmountPercentage(100);
              setAmountValue(0);
              setConvertedAmount(0);
              setShowChoicePop();
            },
          }),
        );
      } else if (selectedPlatform === "External" && isWalletConnected) {
        // console.info("submit external selectedCurrency ====>", selectedCurrency);
        if (!selectedCurrency) {
          showToast(`Please select withdrawal currency!`, "error");
          return;
        }
        if (
          selectedCurrency === "USDT" &&
          convertedAmount < settings?.payment?.usdtMinWithdrawal
        ) {
          showToast(
            `You can claim minimum ${settings?.payment?.usdtMinWithdrawal} USDT.`,
            "error",
          );
          return;
        } else if (
          selectedCurrency === "TON" &&
          convertedAmount < settings?.payment?.tonMinWithdrawal
        ) {
          showToast(
            `You can claim minimum ${settings?.payment?.tonMinWithdrawal} TON.`,
            "error",
          );
          return;
        }
        if (
          settings?.payment?.usdtMaxWithdrawal > 0 &&
          selectedCurrency === "USDT" &&
          convertedAmount > settings?.payment?.usdtMaxWithdrawal
        ) {
          showToast(
            `You can claim maximum ${settings?.payment?.usdtMaxWithdrawal} USDT.`,
            "error",
          );
          return;
        } else if (
          settings?.payment?.tonMaxWithdrawal > 0 &&
          selectedCurrency === "TON" &&
          convertedAmount > settings?.payment?.tonMaxWithdrawal
        ) {
          showToast(
            `You can claim maximum ${settings?.payment?.tonMaxWithdrawal} TON.`,
            "error",
          );
          return;
        }
        setLoading(true);
        dispatch(
          claimExternalApi({
            data: {
              _id: item?._id,
              amount: amountValue,
              coinSymbol: item?.coinSymbol,
              toCoinSymbol: selectedCurrency,
            },
            callBack: (err, res) => {
              if (err) {
                console.error("error claim external", err);
              }
              setLoading(false);
              setSelectedPlatform("Bitanica");
              setSelectedCurrency("");
              setAmountPercentage(100);
              setAmountValue(0);
              setConvertedAmount(0);
              setShowChoicePop();
            },
          }),
        );
      } else {
        if (selectedPlatform === "Bitanica" && !isBitanicaLinked) {
          showToast("Please connect to Bitanica.com to claim!", "error");
          return;
        } else if (selectedPlatform === "External" && isTGWithdrawalDisabled) {
          // ADD: defensive guard, shouldn't normally be reachable since the tab is disabled
          showToast("Telegram withdrawals are currently disabled!", "error");
          return;
        } else if (selectedPlatform === "External" && !isWalletConnected) {
          showToast("Please connect to Telegram wallet!", "error");
          return;
        } else {
          showToast("Please connect to wallet!", "error");
          return;
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleClose = () => {
    try {
      setLoading(false);
      setSelectedPlatform("Bitanica");
      setSelectedCurrency("");
      setAmountPercentage(100);
      setAmountValue(0);
      setConvertedAmount(0);
      setShowChoicePop();
    } catch (error) { }
  };

  const isTelegramWalletDisabled =
    isTGWithdrawalDisabled || item?.type === "expiry" || !isWalletConnected;

  useEffect(() => {
    if (showChoicePop && item?.coinSymbol && !isTelegramWalletDisabled) {
      dispatch(getConversionPrice({ data: { coinSymbol: item.coinSymbol } }));
    }
  }, [dispatch, item?.coinSymbol, showChoicePop, isTelegramWalletDisabled]);

  useEffect(() => {
    // console.info("conversion price", conversionPrice, selectedCurrency, amountValue);
    if (
      selectedCurrency === "USDT" &&
      conversionPrice?.usdtConversionPrice &&
      amountValue
    ) {
      let convertedAmount = (conversionPrice?.usdtConversionPrice * amountValue)
        .toFixed(6)
        .replace(/\.?0+$/, "");
      setConvertedAmount(convertedAmount);
    } else if (
      selectedCurrency === "TON" &&
      conversionPrice?.tonConversionPrice &&
      amountValue
    ) {
      let convertedAmount = (conversionPrice?.tonConversionPrice * amountValue)
        .toFixed(6)
        .replace(/\.?0+$/, "");
      setConvertedAmount(convertedAmount);
    }
  }, [conversionPrice, selectedCurrency, amountValue]);

  useEffect(() => {
    if (amountValue > 0) {
      setCommissionAmount(Number((amountValue - convertedAmount)?.toFixed(2)));
    }
  }, [amountValue, convertedAmount]);

  useEffect(() => {
    if (showChoicePop) {
      if (item?.coinSymbol?.toLowerCase() === "usdt") {
        setSelectedCurrency("USDT");
      } else if (item?.coinSymbol?.toLowerCase() === "ton") {
        setSelectedCurrency("TON");
      } else {
        setSelectedCurrency("");
      }
    }
    if (item) {
      setSelectedItem(item);
    }
  }, [item, showChoicePop]);

  useEffect(() => {
    if (showChoicePop) {
      dispatch(
        getPaymentStatus({
          data: {},
          callBack: (err, res) => {
            if (err) return;
          },
        }),
      );
    }
  }, [dispatch, showChoicePop]);

  useEffect(() => {
    if (selectedItem && amountPercentage === 100) {
      setAmountValue(Number(selectedItem?.leftAmount?.toFixed(6)));
    }
  }, [selectedItem, amountPercentage]);

  // console.info("selectedPlatform", selectedPlatform);
  // console.info("selectedCurrency", selectedCurrency);
  // console.info("amountValue", amountValue);
  // console.info("convertedAmount", convertedAmount);
  // console.info("commissionAmount", commissionAmount);
  return (
    <Modal
      show={showChoicePop}
      onHide={handleClose}
      backdrop="true"
      className={`${styles.choicePop} bottomPop`}
      centered
    >
      <div className="modalWrpper">
        {loading && createPortal(<LoaderCstm />, document.body)}
        <Modal.Body>
          <Button
            onClick={handleClose}
            variant="transparent"
            className="border-0 p-0 position-absolute"
            style={{ top: 15, right: 15, zIndex: 99 }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                fill="#506380"
              />
            </svg>
          </Button>
          <Card className="bg-transparent">
            <Card.Header as="h5" className="text-center text-white">
              {t("claimchoice_pop.select_platform")}
            </Card.Header>
            <Card.Body className="px-0">
              <Tab.Container
                id="left-tabs-example"
                activeKey={activeTab}
                onSelect={(k) => {
                  if (k === "first" && !isBitanicaLinked) return;
                  if (k === "second" && isTelegramWalletDisabled) return;
                  setActiveTab(k);
                }}
              >
                <Nav
                  variant="pills"
                  className={`${styles.tabWrpper}  darkBlueTabs p-2 rounded-3`}
                  style={{ background: "#21212E" }}
                >
                  <Nav.Item className="w-50">
                    <Nav.Link
                      className="d-flex text-center fw-bold align-items-center justify-content-center rounded"
                      eventKey={!isBitanicaLinked ? undefined : "first"}
                      style={
                        !isBitanicaLinked
                          ? { opacity: 0.5, cursor: "not-allowed" }
                          : undefined
                      }
                      onClick={(e) => {
                        if (!isBitanicaLinked) {
                          showToast("Please link Bitanica Wallet!", "info", {
                            autoclose: 1000,
                          });
                          e.preventDefault();
                          e.stopPropagation();
                        } else {
                          setSelectedPlatform("Bitanica");
                          setAmountPercentage(100);
                          setAmountValue(selectedItem?.leftAmount);
                          setActiveTab("first");
                        }
                      }}
                    >
                      Bitanica {t("claimchoice_pop.wallet")}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="w-50">
                    <Nav.Link
                      className="d-flex text-center fw-bold align-items-center justify-content-center rounded"
                      eventKey={isTelegramWalletDisabled ? undefined : "second"}
                      style={
                        isTelegramWalletDisabled
                          ? { opacity: 0.5, cursor: "not-allowed" }
                          : undefined
                      }
                      onClick={(e) => {
                        if (isTGWithdrawalLoading) {
                          e.preventDefault();
                          e.stopPropagation();
                          return;
                        }
                        if (isTGWithdrawalDisabled) {
                          e.preventDefault();
                          e.stopPropagation();
                          showToast("Telegram withdrawals are currently disabled!", "error", {
                            autoclose: 1000,
                          });
                        } else if (item?.type === "expiry" || !isWalletConnected) {
                          e.preventDefault();
                          e.stopPropagation();
                          showToast("Please link Telegram Wallet!", "info", {
                            autoclose: 1000,
                          });
                        } else {
                          setSelectedPlatform("External");
                          setAmountPercentage(100);
                          setAmountValue(selectedItem?.leftAmount);
                          setActiveTab("second");
                        }
                      }}
                    >
                      Telegram {t("claimchoice_pop.wallet")}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content className="pt-3">
                  <Tab.Pane
                    eventKey="first"
                    onClick={() =>
                      isBitanicaLinked ? setSelectedPlatform("Bitanica") : ""
                    }
                  >
                    <div
                      className="position-relative p-3 d-flex align-items-center rounded-3"
                      style={{ background: "#21212E" }}
                    >
                      <input
                        placeholder="Enter Amount"
                        type="text"
                        disabled
                        className="form-control border-0 bg-transparent"
                        value={
                          item?.type === "expiry"
                            ? Number(item?.leftAmount?.toFixed(4))
                            : Number(
                              (
                                (amountPercentage * item?.leftAmount) /
                                100
                              )?.toFixed(4),
                            )
                        }
                      />
                      <img
                        src={item?.coinIcon}
                        alt=""
                        style={{ height: 40, width: 40 }}
                        className="img-fluid flex-shrink-0 rounded-circle"
                      />
                    </div>
                    <div
                      className="mt-5 position-relative"
                      style={{ width: "100%" }}
                    >
                      {![0, 25, 50, 75, 100].includes(amountPercentage) && (
                        <div
                          style={{
                            position: "absolute",
                            left: `${amountPercentage}%`,
                            transform: "translateX(-50%)",
                            top: "-40px",
                            fontSize: "12px",
                            color: "white",
                            background: "#21212E",
                            padding: "8px",
                            borderRadius: "20px",
                            whiteSpace: "nowrap",
                            zIndex: 1,
                          }}
                        >
                          {amountPercentage}%
                        </div>
                      )}
                      <StyledRange
                        className="rangeSlider"
                        min={0}
                        max={100}
                        step={1}
                        onTouchStart={() => {
                          console.info("touch start...");
                        }}
                        onTouchMove={() => {
                          console.info("moving...");
                        }}
                        value={item?.type === "expiry" ? 100 : amountPercentage}
                        onChange={(e) => {
                          // console.info("change", e);
                          if (item?.type !== "expiry") {
                            const val = Number(e.target.value);
                            // console.info("val", val, item?.leftAmount, parseInt((val * item?.leftAmount) / 100));
                            setAmountPercentage(val);
                            setAmountValue(
                              Number(
                                ((val * item?.leftAmount) / 100)?.toFixed(4),
                              ),
                            );
                          } else if (item?.type === "expiry") {
                            setAmountPercentage(100);
                            setAmountValue(
                              Number(item?.leftAmount?.toFixed(4)),
                            );
                          }
                        }}
                        disabled={item?.type === "expiry"}
                      />
                      <div
                        className={`${styles.rangeNum} d-flex align-items-center justify-content-between text-white`}
                      >
                        {[0, 25, 50, 75, 100].map((val) => (
                          <span
                            key={val}
                            className={`${(item?.type === "expiry"
                              ? 100
                              : amountPercentage) === val && styles.active
                              } position-relative`}
                            onClick={() => {
                              if (item?.type !== "expiry") {
                                // console.info("value", val, item?.leftAmount, parseInt((val * item?.leftAmount) / 100));
                                setAmountPercentage(val);
                                setAmountValue(
                                  Number(
                                    ((val * item?.leftAmount) / 100)?.toFixed(
                                      4,
                                    ),
                                  ),
                                );
                              } else if (item?.type === "expiry") {
                                setAmountPercentage(100);
                                setAmountValue(
                                  Number(item?.leftAmount?.toFixed(4)),
                                );
                              }
                            }}
                          >
                            {val}%
                          </span>
                        ))}
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane
                    eventKey="second"
                    disabled={isTelegramWalletDisabled}
                    onClick={() => {
                      if (!isTelegramWalletDisabled) {
                        setSelectedPlatform("External");
                      }
                    }}
                  >
                    {item?.coinSymbol?.toLowerCase() !== "usdt" &&
                      item?.coinSymbol?.toLowerCase() !== "ton" && (
                        <div className="py-3 top text-center">
                          <Card.Header
                            as="h5"
                            className="text-center text-white"
                          >
                            {t("claimchoice_pop.convert")}
                          </Card.Header>
                          <p className="m-0 text-white">
                            {t("claimchoice_pop.convert_descp")}
                          </p>
                        </div>
                      )}
                    {item?.coinSymbol?.toLowerCase() !== "usdt" &&
                      item?.coinSymbol?.toLowerCase() !== "ton" && (
                        <div className="formBody">
                          <div className="py-1">
                            <div
                              className="position-relative p-3  rounded-3"
                              style={{ background: "#21212E" }}
                            >
                              <label
                                htmlFor=""
                                className="form-label m-0"
                                style={{
                                  fontSize: 10,
                                  color: "#848483",
                                }}
                              >
                                {t("claimchoice_pop.from")}
                              </label>
                              <div className="d-flex align-items-center">
                                <input
                                  placeholder="Enter Amount"
                                  type="number"
                                  className="form-control px-0 border-0 bg-transparent"
                                  value={amountValue}
                                  max={item.leftAmount}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (/^\d*\.?\d*$/.test(val)) {
                                      const numericVal = parseFloat(val);
                                      const maxVal = parseFloat(
                                        item.leftAmount,
                                      );

                                      if (
                                        !isNaN(numericVal) &&
                                        numericVal > maxVal
                                      ) {
                                        return;
                                      }
                                      setAmountValue(val);
                                    }
                                  }}
                                />
                                <img
                                  src={item?.coinIcon}
                                  alt=""
                                  style={{
                                    height: 40,
                                    width: 40,
                                  }}
                                  className="img-fluid flex-shrink-0 rounded-circle"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="py-1">
                            {!isDropdownOpen && (
                              <div
                                className="position-relative p-3 rounded-3"
                                style={{ background: "#21212E" }}
                              >
                                <label
                                  className="form-label m-0"
                                  style={{ fontSize: 10, color: "#848483" }}
                                >
                                  {item.coinSymbol?.toLowerCase() !== "usdt" &&
                                    item.coinSymbol?.toLowerCase() !== "ton"
                                    ? t("claimchoice_pop.to")
                                    : t("claimchoice_pop.final_amount")}
                                </label>
                                <div
                                  className="d-flex align-items-center"
                                  onClick={() => {
                                    const symbol =
                                      item.coinSymbol?.toLowerCase();
                                    if (symbol !== "usdt" && symbol !== "ton") {
                                      setIsDropdownOpen(true);
                                    }
                                  }}
                                >
                                  <input
                                    placeholder={
                                      item.coinSymbol?.toLowerCase() !==
                                        "usdt" &&
                                        item.coinSymbol?.toLowerCase() !== "ton"
                                        ? t("claimchoice_pop.choose_crypto")
                                        : t("claimchoice_pop.final_amount")
                                    }
                                    type="text"
                                    className="form-control border-0 bg-transparent px-0"
                                    readOnly
                                    value={convertedAmount}
                                    style={{
                                      color: selectedCurrency
                                        ? "#fff"
                                        : "#848483",
                                    }}
                                  />
                                  {selectedCurrency ? (
                                    <img
                                      src={
                                        selectedCurrency === "TON"
                                          ? "https://sound.bitanicagames.com/ton.png"
                                          : "https://minehunt-live.s3.us-east-2.amazonaws.com/usdt%28ton%29.png"
                                      }
                                      alt=""
                                      style={{ height: 40, width: 40 }}
                                      className="img-fluid flex-shrink-0 rounded-circle"
                                    />
                                  ) : (
                                    <span
                                      className="right rounded-circle"
                                      style={{
                                        height: 40,
                                        width: 40,
                                        background: "#5D5D5D",
                                      }}
                                    ></span>
                                  )}
                                </div>
                              </div>
                            )}

                            {isDropdownOpen && (
                              <div
                                className="position-relative rounded-3"
                                style={{ background: "#21212E" }}
                              >
                                <Dropdown
                                  show={isDropdownOpen}
                                  onToggle={() => { }}
                                >
                                  <div
                                    className="border-0 p-3 text-start w-100"
                                    onClick={() => setIsDropdownOpen(false)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <label
                                      className="form-label m-0"
                                      style={{ fontSize: 10, color: "#848483" }}
                                    >
                                      {t("claimchoice_pop.to")}
                                    </label>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <p
                                        className="m-0"
                                        style={{
                                          fontSize: 16,
                                          color: selectedCurrency
                                            ? "#ffffff"
                                            : "#848483",
                                        }}
                                      >
                                        {t("claimchoice_pop.choose_crypto")}
                                      </p>
                                      <span
                                        className="right rounded-circle"
                                        style={{
                                          height: 40,
                                          width: 40,
                                          background: "#5D5D5D",
                                        }}
                                      ></span>
                                    </div>
                                  </div>

                                  <Dropdown.Menu className="w-100 show">
                                    <Dropdown.Item
                                      href="#"
                                      className="d-flex w-100 align-items-center justify-content-between gap-10"
                                      onClick={() => {
                                        setSelectedCurrency("USDT");
                                        setIsDropdownOpen(false);
                                      }}
                                    >
                                      <span className="text-white">USDT</span>
                                      <img
                                        style={{ height: 40, width: 40 }}
                                        src="https://minehunt-live.s3.us-east-2.amazonaws.com/usdt%28ton%29.png"
                                        alt=""
                                        className="img-fluid flex-shrink-0 rounded-circle"
                                      />
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      href="#"
                                      className="d-flex w-100 align-items-center justify-content-between gap-10"
                                      onClick={() => {
                                        setSelectedCurrency("TON");
                                        setIsDropdownOpen(false);
                                      }}
                                    >
                                      <span className="text-white">TON</span>
                                      <img
                                        style={{ height: 40, width: 40 }}
                                        src="https://sound.bitanicagames.com/ton.png"
                                        alt=""
                                        className="img-fluid flex-shrink-0 rounded-circle"
                                      />
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            )}
                          </div>
                          <div className="py-1">
                            <div className="d-flex align-items-center gap-10 text-white text-center">
                              {selectedCurrency !== "TON" && (
                                <div
                                  className="w-100 p-2 rounded-2"
                                  style={{
                                    background: "#50AF95",
                                    fontSize: 10,
                                  }}
                                >
                                  1 {item.coinSymbol} ={" "}
                                  {Number(conversionPrice?.usdtConversionPrice)}{" "}
                                  USDT
                                </div>
                              )}

                              {selectedCurrency !== "USDT" && (
                                <div
                                  className="w-100 p-2 rounded-2"
                                  style={{
                                    background: "#0098EA",
                                    fontSize: 10,
                                  }}
                                >
                                  1 {item.coinSymbol} ={" "}
                                  {Number(conversionPrice?.tonConversionPrice)}{" "}
                                  TON
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    {(item?.coinSymbol?.toLowerCase() === "usdt" ||
                      item?.coinSymbol?.toLowerCase() === "ton") && (
                        <div className="py-3 top text-center">
                          <Card.Header as="h5" className="text-center text-white">
                            {t("claimchoice_pop.withdraw")}
                          </Card.Header>
                          <p className="m-0 text-white">
                            {t("claimchoice_pop.withdraw_text")}
                          </p>
                        </div>
                      )}
                    {(item?.coinSymbol?.toLowerCase() === "usdt" ||
                      item?.coinSymbol?.toLowerCase() === "ton") && (
                        <div>
                          <div
                            className="position-relative p-3 d-flex align-items-center rounded-3"
                            style={{ background: "#21212E" }}
                          >
                            <input
                              placeholder={t("claimchoice_pop.enter_amount")}
                              type="text"
                              disabled
                              className="form-control border-0 bg-transparent"
                              value={Number(
                                (amountPercentage * item?.leftAmount) / 100,
                              )}
                            />
                            <img
                              src={item?.coinIcon}
                              alt=""
                              style={{ height: 40, width: 40 }}
                              className="img-fluid flex-shrink-0 rounded-circle"
                            />
                          </div>

                          <div
                            className="mt-5 position-relative"
                            style={{ width: "100%" }}
                          >
                            {![0, 25, 50, 75, 100].includes(amountPercentage) && (
                              <div
                                style={{
                                  position: "absolute",
                                  left: `${amountPercentage}%`,
                                  transform: "translateX(-50%)",
                                  top: "-40px",
                                  fontSize: "12px",
                                  color: "white",
                                  background: "#21212E",
                                  padding: "8px",
                                  borderRadius: "20px",
                                  whiteSpace: "nowrap",
                                  zIndex: 1,
                                }}
                              >
                                {amountPercentage}%
                              </div>
                            )}

                            <StyledRange
                              className="rangeSlider"
                              min={0}
                              max={100}
                              step={1}
                              value={amountPercentage}
                              onChange={(e) => {
                                const val = Number(e.target.value);
                                setAmountPercentage(val);
                                setAmountValue(
                                  Number(
                                    ((val * item?.leftAmount) / 100)?.toFixed(4),
                                  ),
                                );
                              }}
                              disabled={item?.type === "expiry"}
                            />

                            <div
                              className={`${styles.rangeNum} d-flex align-items-center justify-content-between text-white`}
                            >
                              {[0, 25, 50, 75, 100].map((val) => (
                                <span
                                  key={val}
                                  className={`${(item?.type === "expiry"
                                    ? 0
                                    : amountPercentage) === val && styles.active
                                    } position-relative`}
                                  onClick={() => {
                                    if (item?.type !== "expiry") {
                                      // console.info("value", val, item?.leftAmount, parseInt((val * item?.leftAmount) / 100));
                                      setAmountPercentage(val);
                                      setAmountValue(
                                        Number(
                                          (
                                            (val * item?.leftAmount) /
                                            100
                                          )?.toFixed(4),
                                        ),
                                      );
                                    } else if (item?.type === "expiry") {
                                      setAmountPercentage(0);
                                      setAmountValue(0);
                                    }
                                  }}
                                >
                                  {val}%
                                </span>
                              ))}
                            </div>
                          </div>

                          <div
                            style={{
                              backgroundColor: "#21212E",
                            }}
                            className="d-flex flex-column align-items-center justify-content-center mt-4 text-white rounded-3 py-2"
                          >
                            <div className="d-flex flex-column gap-10 w-100 px-3">
                              <div className="d-flex align-items-center justify-content-between">
                                <div>{t("claimchoice_pop.commission")}:</div>
                                <div className="">
                                  {commissionAmount}{" "}
                                  {item?.coinSymbol?.toUpperCase()}
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-between fw-bold">
                                <div>{t("claimchoice_pop.you_get")}:</div>
                                <div>
                                  {amountValue > 0 ? convertedAmount : 0}{" "}
                                  {item?.coinSymbol?.toUpperCase()}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
              <Form onSubmit={handleSubmit}>
                <div className="btnWRpper mt-4">
                  <Button
                    variant="primary"
                    type="submit"
                    className={`${styles.submitBtn} w-100 d-flex align-items-center justify-content-center text-uppercase`}
                  // disabled={
                  //     selectedPlatform === "External" && (
                  //         (selectedCurrency === "USDT" && (
                  //             convertedAmount < settings?.payment?.usdtMinWithdrawal ||
                  //             (settings?.payment?.usdtMaxWithdrawal > 0 &&
                  //                 convertedAmount > settings?.payment?.usdtMaxWithdrawal)
                  //         )) ||
                  //         (selectedCurrency === "TON" && (
                  //             convertedAmount < settings?.payment?.tonMinWithdrawal ||
                  //             (settings?.payment?.tonMaxWithdrawal > 0 &&
                  //                 convertedAmount > settings?.payment?.tonMaxWithdrawal)
                  //         ))
                  //     )
                  // }
                  >
                    {t("claimchoice_pop.submit")}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
      </div>
    </Modal>
  );
};

const StyledRange = styled.input.attrs({ type: "range" })`
  width: 100%;
  height: 8px;
  appearance: none;
  border-radius: 4px;
  background: ${({ value }) => `
    linear-gradient(
      to right,
      #202267 0%,
      #242AFC ${value}%,
      #21212E ${value}%,
      #21212E 100%
    )
  `};
  &::-webkit-slider-runnable-track {
    height: 8px;
    border-radius: 5px;
    background: transparent; /* Let the parent input background show */
  }

  &::-webkit-slider-thumb {
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #242afc;
    border: none;
    margin-top: -6px;
    cursor: pointer;
  }

  &::-moz-range-track {
    height: 8px;
    border-radius: 5px;
    background: transparent;
  }

  &::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background-color: #242afc;
    border: none;
    border-radius: 50%;
    cursor: pointer;
  }

  /* Optional: drag active effect */
  &:active::-webkit-slider-thumb {
    background-color: #1a1aff;
  }

  &:active::-moz-range-thumb {
    background-color: #1a1aff;
  }
`;

export default ClaimChoicePop;
